<template>
  <v-form ref="form" v-model="valid" :lazy-validation="true">
    <v-card>
      <div class="message-form__content">
        <v-card-title>
          <span class="headline">{{ titlePrefix }} Message</span>
        </v-card-title>

        <v-card-text>
          <v-textarea
            name="message"
            v-model="ownItem.message"
            label="Message"
            :auto-grow="true"
            rows="1"
            :rules="stringValidation"
            :disabled="isSaving"
          ></v-textarea>
        </v-card-text>
      </div>
      <v-card-actions>
        <v-btn depressed :disabled="!valid" :loading="isSaving" color="primary" @click="submit">Save</v-btn>
        <v-btn text @click="cancel" color="primary" :disabled="isSaving">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>

export default {
  props: {
    item: {
      type: Object
    }
  },
  data () {
    return {
      valid: true,
      stringValidation: [v => (v != null && v !== '') || 'Cannot be empty'],
      ownItem: {}
    }
  },
  computed: {
    isSaving () {
      return this.$store.getters.isLoadingFor(['messages.create', 'messages.update']);
    },
    titlePrefix () {
      return this.ownItem.id ? 'Edit' : 'Add';
    }
  },
  watch: {
    item: {
      immediate: true,
      handler (newVal) {
        this.setOwnItem(newVal);
      }
    }
  },
  methods: {
    setOwnItem (item) {
      if (item) {
        this.ownItem = Object.assign({}, item);
      } else {
        this.ownItem = {};
      }

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    submit () {
      if (!this.$refs.form.validate()) {
        return;
      }
      const item = Object.assign({}, this.ownItem);
      this.$emit('submit', item);
    },
    cancel () {
      this.$emit('cancel')
    },
    reset () {
      this.setOwnItem(null);
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
